import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function discount(token, params) {

    return Api.post(REQUEST_URLS.COMPANY_APPROVAL.DISCOUNT, params,{
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default discount;